import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

export const MarketingContactSchema = z.object({
  name: z.string().min(1).max(200),
  /** E.164 from the shared phone input; the sales team replies on WhatsApp. */
  phone: z.string().trim().max(30).refine((value) => isValidPhoneNumber(value)),
  email: z.string().trim().email().max(320).optional().or(z.literal('')),
  venue: z.string().max(200).optional().or(z.literal('')),
  message: z.string().min(1).max(5000),
  /** Shared with the browser pixel so Meta deduplicates the Lead event. */
  eventId: z.string().uuid().optional(),
  /** Honeypot: real users never fill this hidden field. */
  website: z.literal('').optional(),
});

export type MarketingContactData = z.infer<typeof MarketingContactSchema>;
